import React from "react";
import { Stack, Button } from "@mui/material";

type MasterActionButtonsProps = {
  handleEnable?: () => void;
  handleDisable?: () => void;
  row?: any;
};

export const MasterActionButtons = (props: MasterActionButtonsProps) => {
  const { handleEnable, handleDisable, row } = props;
  
  const isDeleted = row?.markAsDeleted === true;
  return (
    <Stack direction="row" spacing={1} sx={{ whiteSpace: "nowrap" }}>
      <Button
        variant="contained"
        size="small"
        color="primary"
        disabled={!isDeleted}
        sx={{ textTransform: "none", px: 2 }}
        onClick={handleEnable}
      >
        Enable
      </Button>
      <Button
        variant="contained"
        size="small"
        color="primary"
        disabled={isDeleted}
        sx={{ textTransform: "none", px: 2 }}
        onClick={handleDisable}
      >
        Disable
      </Button>
    </Stack>
  );
};
